<template>
    <v-card class="mx-auto" min-width="500">

        <v-card-title class="text-h6 font-weight-regular justify-space-between">
        <span>Επεξεργασία παραστατικού</span>
        </v-card-title>

        <v-dialog v-model="selectAccountDialog" max-width="400">
            <v-card class="ma-4" max-width="350" v-bind:key="account.id" v-for="account in selectAccountDialogEntries">
                <v-card-title class="text-wrap">
                    <p>{{account.name}}</p>
                </v-card-title>
              
                <v-card-subtitle>{{ `ΑΦΜ: ${account.tax_registration_number || '-'}` }}</v-card-subtitle>
              
                <v-card-text>
                    <v-container>
                        <v-row>
                            <div>{{account.city}} {{account.zipcode}}</div>
                        </v-row>
                        <v-row>
                            <div>{{account.address}}</div>
                        </v-row>
                        <v-row>
                            <div>{{account.telephone}}</div>
                        </v-row>
                    </v-container>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" @click="updateAccount(selectAccountDialogShownFor, account); closeSelectAcountDialog();">ΕΠΙΛΟΓΗ</v-btn>
                </v-card-actions>
            </v-card>
     
        </v-dialog>
        <!-- ΒΑΣΙΚΑ ΣΤΟΙΧΕΙΑ -->

        <v-window v-model="step">
            <v-window-item :value="0">
                <v-card-text>
                    <h3 class="text-h6 font-weight-light mb-4">Βασικά στοιχεία</h3>
                    
                    <v-select 
                        v-bind:items="documentTypes" 
                        v-model="selectedDocumentType"
                        return-object
                        
                        item-text="description" 
                        label="Είδος παραστατικού"
                        v-bind:error-messages="allerrors.document_type_id"
                        disabled>
                    </v-select>

                    <v-select 
                        v-show="selectedDocumentType.series.length > 1 || (selectedSeries.name && selectedSeries.name.length > 0)"
                        v-bind:items="selectedDocumentType.series"
                        v-model="selectedSeries"
                        return-object
                        item-text="name"
                        item-value="id" 
                        label="Σειρά παραστατικού"
                        v-bind:error-messages="allerrors.document_series"
                        disabled>
                    </v-select>

                    <v-text-field 
                        v-if="selectedSeries.autonumbered == false"
                        v-model.number="document_number" 
                        label="Αριθμός παραστατικού"
                        v-bind:error-messages="allerrors.document_series"
                        v-bind:disabled="selectedSeries.autonumbered">
                    </v-text-field>

                    <v-menu
                        v-model="menu2"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        min-width="auto">
                        <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                                v-model="document_issue_date"
                                label="Ημερομηνία έκδοσης"
                                append-icon="mdi-calendar"
                                readonly
                                v-bind="attrs"
                                v-on="on">
                            </v-text-field>
                        </template>
                        <v-date-picker
                            v-model="document_issue_date"
                            @input="menu2 = false"
                            v-bind:min="minDate"
                            v-bind:max="maxDate">
                        </v-date-picker>
                    </v-menu>


                </v-card-text>
            </v-window-item>



            <!-- ΠΕΛΑΤΗΣ -->

            <v-window-item :value="1">
                <v-card-text>
                    <v-row>
                        <h3 class="text-h6 font-weight-light mb-2">Στοιχεία πελάτη</h3>
                        <v-spacer></v-spacer>
                        <v-btn text color="warning" v-on:click="clearCustomerFields">ΚΑΘΑΡΙΣΜΑ</v-btn>
                    </v-row>

                    <v-text-field 
                        v-bind:readonly="customerNotEditable"
                        v-model="customer.name" 
                        append-icon="mdi-account-search"
                        @click:append="searchAccountByName('customer')"
                        v-bind:error-messages="allerrors.customer.name">
                            <template #label>
                                <span class="red--text"><strong>* </strong></span>Επωνυμία
                            </template>
                    </v-text-field>
                    <v-row>
                        <v-col cols="12" sm="6">
                            <v-text-field 
                                v-bind:readonly="customerNotEditable"
                                v-model="customer.tax_registration_number"
                                label="ΑΦΜ"
                                append-icon="mdi-account-search"
                                @click:append="searchAccountByTaxRegistrationNumber('customer')"
                                v-bind:loading="disabledTaxRegistrationNumberFields.customer"
                                v-bind:error-messages="allerrors.customer.tax_registration_number">
                            </v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6">
                            <v-select 
                                v-bind:readonly="customerNotEditable"
                                v-model="customer.tax_registration_office_id"
                                v-bind:items="taxOffices" 
                                item-text="name" 
                                item-value="id" 
                                label="ΔΟΥ"
                                v-bind:error-messages="allerrors.customer.tax_registration_office_id">
                            </v-select>
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col cols="12">
                            <v-text-field 
                                v-bind:readonly="customerNotEditable"
                                v-model="customer.jobtitle" 
                                label="Επάγγελμα"
                                append-icon="mdi-account-search"
                                v-bind:error-messages="allerrors.customer.jobtitle">
                            </v-text-field>
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col cols="12" sm="6">
                            <v-select 
                                v-bind:readonly="customerNotEditable"
                                v-model="customer.country_id"
                                v-bind:items="countries" 
                                item-text="name_gr" 
                                item-value="id"
                                v-bind:error-messages="allerrors.customer.country_id">
                                    <template #label>
                                        <span class="red--text"><strong>* </strong></span>Χώρα
                                    </template>
                            </v-select>
                        </v-col>

                        <v-col cols="12" sm="6">
                            <v-combobox
                                v-bind:readonly="customerNotEditable"
                                v-model="customer.city"
                                v-bind:items="filteredCustomerCities"
                                v-bind:error-messages="allerrors.customer.city">
                                    <template #label>
                                        <span class="red--text"><strong>* </strong></span>Πόλη
                                    </template>
                            </v-combobox>
                        </v-col>
                        
                    </v-row>                    

                    <v-row>
                        <v-col cols="12" sm="8">
                            <v-text-field 
                                v-bind:readonly="customerNotEditable"
                                v-model="customer.address" 
                                v-bind:error-messages="allerrors.customer.address">
                                    <template #label>
                                        <span class="red--text"><strong>* </strong></span>Διεύθυνση
                                    </template>
                            </v-text-field>
                        </v-col>

                        <v-col cols="12" sm="4">
                            <v-text-field 
                                v-bind:readonly="customerNotEditable"
                                v-model="customer.zipcode" 
                                label="ΤΚ"
                                v-bind:error-messages="allerrors.customer.zipcode">
                            </v-text-field>
                        </v-col>
                    </v-row>            

                    <v-row>
                        <v-col cols="12" sm="6">
                            <v-text-field 
                                v-bind:readonly="customerNotEditable"
                                v-model="customer.telephone" 
                                label="Αριθμός τηλεφώνου"
                                append-icon="mdi-account-search"
                                v-bind:error-messages="allerrors.customer.telephone">
                            </v-text-field>
                        </v-col>

                        <v-col cols="12" sm="6">
                            <v-text-field 
                                v-bind:readonly="customerNotEditable"
                                v-model="customer.mobile" 
                                label="Αριθμός κινητού"
                                append-icon="mdi-account-search"
                                v-bind:error-messages="allerrors.customer.mobile">
                            </v-text-field>
                        </v-col>
                    </v-row>                    


                    <v-row>
                        <v-col cols="12" sm="6">
                            <v-text-field 
                                v-bind:readonly="customerNotEditable"
                                v-model="customer.fax" 
                                label="Αριθμός Φαξ"
                                v-bind:error-messages="allerrors.customer.fax">
                            </v-text-field>
                        </v-col>

                        <v-col cols="12" sm="6">
                            <v-text-field 
                                v-bind:readonly="customerNotEditable"
                                v-model="customer.email" 
                                label="E-Mail"
                                v-bind:error-messages="allerrors.customer.email">
                            </v-text-field>
                        </v-col>
                    </v-row>
                </v-card-text>

            </v-window-item>


            <v-window-item :value="2">
                <v-card-text>
                    <h3 class="text-h6 font-weight-light mb-4">{{this.selectedDocumentType.suggest_gross_values ? 'Τελικό' : 'Μερικό' }} σύνολο: {{totalChargedAmount}}</h3>

                    <v-select
                        v-if="selectedDocumentTypeIsPayable"
                        v-bind:items="filteredPaymentTypes" 
                        v-model="selectedPaymentType"
                        return-object
                        
                        item-text="description" 
                        label="Τρόπος πληρωμής"
                        v-bind:error-messages="allerrors.payment_type_id">
                    </v-select>


                    <template v-for="charge in charges">
                        <vuetify-money
                            v-bind:key="charge.id"
                            v-bind:label="charge.description"
                            v-model="charge.amount"
                            v-bind:options="moneyFieldOptions">
                        </vuetify-money>
                    </template>                    
                </v-card-text>

            </v-window-item>

            <v-window-item :value="3">
                <v-card-text>
                    <h3 class="text-h6 font-weight-light mb-4">Παρατηρήσεις - Σχόλια</h3>

                    <v-text-field
                        v-model="comments"
                        label="Παρατηρήσεις">
                    </v-text-field>

                    <v-textarea
                        v-model="comments2"
                        label="Σχόλια">
                    </v-textarea>
                    
                </v-card-text>

            </v-window-item>

            <v-window-item :value="4">
                <v-card-text>
                    <h3 class="text-h6 font-weight-light mb-4">Συνοψη παραστατικού</h3>
                    
                    <v-text-field
                        readonly 
                        v-model="selectedDocumentType.description" 
                        label="Παραστατικό">
                    </v-text-field>

                    <v-text-field
                        readonly 
                        v-model="document_issue_date" 
                        label="Ημερομηνία">
                    </v-text-field>

                    <v-text-field
                        readonly 
                        v-model="customer.name" 
                        label="Πελάτης">
                    </v-text-field>

                    <v-text-field
                        readonly 
                        v-model="totalChargedAmountSummary" 
                        v-bind:label="totalChargedAmountSummaryLabel">
                    </v-text-field>

                    <div class="text-center">
                        <v-btn 
                            color="success" 
                            @click="saveDocument" 
                            v-bind:loading="saveDocumentButtonDisabled">
                            ΑΠΟΘΗΚΕΥΣΗ
                        </v-btn>
                    </div>
                </v-card-text>

            </v-window-item>


        </v-window>

        <v-card-actions>
            <v-btn
                v-bind:disabled="step <= 0"
                text
                v-on:click="step--"
                color="primary">
                ΠΙΣΩ
            </v-btn>
            <v-spacer></v-spacer>
            <v-item-group
                v-model="step"
                class="text-center"
                mandatory>
                <v-item
                        v-for="n in totalSteps"
                        v-bind:key="`btn-${n}`"
                        v-slot="{ active, toggle }">
                    <v-btn
                        v-bind:input-value="active"
                        icon
                        dense
                        x-small
                        disabled
                        @click="toggle">
                        <v-icon color="blue">mdi-record</v-icon>
                    </v-btn>
                </v-item>
            </v-item-group>

            <v-spacer></v-spacer>
            <v-btn
                v-bind:disabled="(step >= totalSteps - 1) || (stepCompleted == false)"
                color="primary"
                depressed
                @click="scroll2top(); step++;">
                ΕΠΟΜΕΝΟ
            </v-btn>
        </v-card-actions>


    </v-card>

</template>

<script>
import goTo from 'vuetify/lib/services/goto'
import currency from "currency.js"

export default {
    data () {
        return {
            moneyFieldOptions: {
                locale: "el-GR",
                prefix: "€",
                suffix: "",
                length: 8,
                precision: 2
            },

            step: 0,
            totalSteps: 5,
            menu2: false,
            saveDocumentButtonDisabled: false,
            
            allerrors : {
                customer: {},
             },

            documentTypes: [],
            documentSeries: [],
            taxOffices: [],
            countries: [],
            paymentTypes: [],
            charges: [],




            selectedDocumentType: {
                series: [],
                charges: []
            },

            selectedSeries: {},

            filteredDocumentSeries: [],

            document_number: '',
            document_issue_date: '',

            comments: '',
            comments2: '',
            customer: {},
            

            selectedPaymentType: {},

            dialog: false,
            dialogDelete: false,
            selectAccountDialog: false,
            selectAccountDialogEntries: [],
            selectAccountDialogShownFor: '',

            disabledTaxRegistrationNumberFields : {
                customer: false
            },

            minDate: null,
            maxDate: null
        }
    },

    created() {
        this.initialize()
    },

    watch: {
        selectedDocumentType: function (val) {
            this.document_number = ''
            this.selectedSeries = {}

            this.charges = this.selectedDocumentType.charges.map(x => { 
                return {
                    id: x.id,
                    description: x.description,
                    amount: x.default_net_amount ?? 0.0
                } 
            });

            if (this.selectedDocumentType.series.length == 1)
                this.selectedSeries = this.selectedDocumentType.series[0]


        },
    },

    computed: {

        totalChargedAmountSummaryLabel() {
            return this.selectedDocumentType.suggest_gross_values ? 'Μικτό σύνολο' : 'Καθαρές χρεώσεις'
        },

        filteredCustomerCities() { return [] },
        
        selectedDocumentTypeDescription () { 
            if (this.document_type_id && this.documentTypes.length > 0)
                return this.documentTypes.find(x => x.id == this.document_type_id).description

            return ''
        },

        selectedDocumentTypeIsPayable() {
            return (this.selectedDocumentType.payable == true);
        },

        totalChargedAmount() {
            const reducer = (a, b) => (currency(a).add(b))

            return this.charges.map(x => parseFloat(x.amount)).reduce(reducer, 0.0).value
        },

        filteredPaymentTypes() {
            if (this.selectedDocumentType && (this.selectedDocumentType.id ?? 0) > 0) {
                // console.log(`selected document inert: ${selectedDocumentType.inert}`)

                if (this.selectedDocumentType.updates_ledger == false)
                    return this.paymentTypes.filter(x => x.flag_credit == true)
                
                return this.paymentTypes
            }
                
        },
        
        totalChargedAmountSummary() {
            
            let chargedAmount = this.totalChargedAmount

            if (this.selectedPaymentType && chargedAmount)
                return `(${this.selectedDocumentType.payable ? this.selectedPaymentType.description : "ΠΙΣΤΩΣΗ"}) ${chargedAmount}`
        },

        stepCompleted() {
            switch (this.step) {
                case 0:
                    if (!this.selectedDocumentType.id)
                        return false
                    
                    if (!this.selectedSeries.id)
                        return false
                    
                    if (!this.document_issue_date)
                        return false

                    if (this.selectedSeries.autonumbered == false && (this.document_number.toString().length > 0 == false))
                        return false
                    
                    break

                case 1:
                    if ((this.customer.name ?? '').length > 1 == false)
                        return false

                    if ((this.customer.country_id ?? 0) > 0 == false)
                        return false
                    
                    if ((this.customer.city ?? '').length > 1 == false)
                        return false

                    if ((this.customer.address ?? '').length > 1 == false)
                        return false
                    
                    break

                case 2:
                    if (this.selectedDocumentType.payable == true && ((this.selectedPaymentType.id ?? 0 > 0) == false))
                        return false

                    if (this.totalChargedAmount > 0 == false)
                        return false

                    break

                default:
                    return true
            }
        },

        customerNotEditable() {
            return (this.customer.id ?? 0) > 0
        }
    },


    methods: {
        mixmatch (item) {
            item.package = this.packages.find(pkg => pkg.id == item.package_id)

            return item;
        },

        scroll2top() {
            goTo(0)
        },

        clearCustomerFields() {
            this.customer = {}
        },

        initialize() {
            this.$store.dispatch('currentUser/getCurrentUser')

            this.document_issue_date = this.$localDateString()

            axios.all([
                axios.get('/api/document-types/service'),
                axios.get('/api/tax-offices'),
                axios.get('/api/countries'),
                axios.get('/api/tax-authority/payment-types'),
            ]).then(
                axios.spread(
                (
                    documentTypesResponse, 
                    taxOfficesResponse, 
                    countriesResponse, 
                    paymentTypesResponse,
                ) => {
                    this.documentTypes = documentTypesResponse.data.sort((a, b) => a.description.localeCompare(b.description))
                    this.taxOffices = taxOfficesResponse.data.sort((a, b) => a.name.localeCompare(b.name))
                    this.countries = countriesResponse.data
                    this.paymentTypes = paymentTypesResponse.data

                    this.preloadDocument(this.$route.params.id)
            })).catch(error => { console.log(error) })
        },


        saveDocument() {
            this.saveDocumentButtonDisabled = true;

            let requestBody = {
                document_type_id: this.selectedDocumentType.id,
                document_series_id: this.selectedSeries.id,
                document_issue_date: this.document_issue_date,
                document_number: this.document_number,

                customer: this.customer,
                
                payment_type_id: this.selectedDocumentTypeIsPayable ? this.selectedPaymentType.id : this.paymentTypes.find(x => x.flag_credit == true).id,
                charges: this.charges.map(x => { return { charge_type_id : x.id, amount: x.amount, gross_value: this.selectedDocumentType.suggest_gross_values }}),
                
                comments: (this.comments?.length ?? '' > 0) ? this.comments : null,
                comments2: (this.comments2?.length ?? '' > 0) ? this.comments2 : null,
            }

            axios.patch(`/api/documents/service/${this.$route.params.id}`, requestBody)
            .then(_ => { 
                this.$router.push({ name: 'servicedocuments' })
            })
            .catch(error => { 
                console.log(error)
                
                // if (error.response.data)
                //     if (errors.response.data.errors)
                //         this.allerrors = error.response.data.errors
              })
            .finally( () => { this.saveDocumentButtonDisabled = false })
        },

        async searchAccountByTaxRegistrationNumber(accountPropertyName) {

            if (this.disabledTaxRegistrationNumberFields[accountPropertyName] == true)
                return

            this.disabledTaxRegistrationNumberFields[accountPropertyName] = true

            let needle = this[accountPropertyName].tax_registration_number
            let response = await axios.get(`/api/accounts/search/tax-registration-number/${needle}`)

            this.disabledTaxRegistrationNumberFields[accountPropertyName] = false
            
            if (response.data.length == 1) {
                let account = response.data[0]

                this.updateAccount(accountPropertyName, account)
                
                if (this.taxOffices.filter(taxOffice => taxOffice.code == account.tax_office.code).length > 0 == false) {
                    //this.taxOffices.push(account.tax_οffice)
                    axios.get('/api/tax-offices')
                    .then(response => this.taxOffices = response.data)
                }
            } else if (response.data.length > 1) {
                this.selectAccountDialogEntries = response.data
                this.selectAccountDialogShownFor = accountPropertyName
                this.selectAccountDialog = true
            }
            
        },

        async searchAccountByName(accountPropertyName) {
            let needle = this[accountPropertyName].name
            let response = await axios.get(`/api/accounts/search/name/${needle}`)

            if (response.data.length == 1)
                this.updateAccount(accountPropertyName, response.data[0])
            else if (response.data.length > 1) {

                this.selectAccountDialogEntries = response.data
                this.selectAccountDialogShownFor = accountPropertyName
                this.selectAccountDialog = true
            }
        },

        closeSelectAcountDialog() {
            this.selectAccountDialog = false
            this.selectAccountDialogEntries = []
            this.selectAccountDialogShownFor = null
        },

        updateAccount(accountPropertyName, data) {
            this[accountPropertyName] = {
                id: data.id,
                address : data.address,
                name : data.name,
                city : data.city,
                telephone : data.telephone,
                fax : data.fax,
                email : data.email,
                country_id : data.country_id,
                mobile : data.mobile,
                tax_registration_number: data.tax_registration_number,
                zipcode: data.zipcode,
                tax_registration_office_id: data.tax_registration_office_id,
                jobtitle: data.jobtitle
            }
        },

        async preloadDocument(documentId) {
            console.log(`fetching ${documentId}`)
            const response = await axios.get(`/api/documents/service/${documentId}`)

            console.log(response.data)
            
            if (response.data.invoice_mark?.length > 0) {
                this.$router.push({name: 'servicedocument'});
                return;
            }

            this.minDate = response.data.reissue_stuff.minNewDate
            this.maxDate = response.data.reissue_stuff.maxNewDate
                

            this.selectedDocumentType = this.documentTypes.find(x => x.id == response.data.document_type_id)

            this.document_issue_date = response.data.issue_date
            
        
            axios.get(`/api/accounts/${response.data.customer_id}`)
            .then(response => this.updateAccount('customer', response.data))


            this.comments = response.data.comments
            this.comments2 = response.data.comments2

            this.selectedPaymentType = this.paymentTypes.find(x => x.id == response.data.payment_type_id)

            
            this.$nextTick(() => {
                this.document_number = response.data.document_number
                this.selectedSeries = this.selectedDocumentType.series.find(x => x.id == response.data.document_series_id)

                for (const charge of response.data.charges)
                {
                    console.log(`Trying to restore charge with type id ${charge.charge_type_id}`)

                    let target = this.charges.find(x => x.id == charge.charge_type_id)

                    console.log(target)

                    if (charge.saved_as_gross)
                        target.amount = parseFloat(charge.net_amount) + parseFloat(charge.vat_amount)
                    else
                        target.amount = parseFloat(charge.net_amount)
                    
                }
            })
                
            }
            //.catch(error => { console.log(error) })

            
    }
}
</script>

<style scoped>

</style>